import React from 'react';
import { Link } from 'react-router-dom';
import './UtilityCard.css';

const UtilityCard = ({ utility }) => {
  // Utilities are now public - no authentication required
  return (
    <Link 
      to={utility.path} 
      className="utility-card"
    >
      <div className="utility-icon">{utility.icon}</div>
      <h3 className="utility-title">{utility.title}</h3>
      <p className="utility-description">{utility.description}</p>
      <span className="utility-category">{utility.category}</span>
    </Link>
  );
};

export default UtilityCard;

